import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {MAX_TOOLTIP_TEXT_LENGTH, SchemaField} from 'schemas/fields/SchemaFieldConstants';
import FormInput from 'ui-library/bs/FormInput';
import {GRAY_DARK} from 'ui-library/Colors';
import ErrorMessage from 'ui-library/ErrorMessage';
import InfoIcon from 'ui-library/icons/InfoIcon';
import {ElementKeyboardEvent, InputChangeEvent} from 'util/Types';

interface Props {
  editingTooltipText: string;
  field: SchemaField;
  isEditingOrCreating: boolean;
  isDisabled: boolean;
  onChange: (e: InputChangeEvent) => void;
  onKeyDown: (e: ElementKeyboardEvent) => void;
}

export function getTooltipTextError(text: string): string | null {
  if ([...text].length > MAX_TOOLTIP_TEXT_LENGTH) {
    return `Tooltip text cannot exceed ${MAX_TOOLTIP_TEXT_LENGTH} characters.`;
  }
  return null;
}

export default function SchemaFieldTooltipTextField(props: Props): JSX.Element | null {
  if (props.isEditingOrCreating) {
    const error = getTooltipTextError(props.editingTooltipText);
    return (
      <>
        <FormInput
          type="textarea"
          name="tooltip_text"
          value={props.editingTooltipText}
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
          placeholder="Field tooltip text (optional, visible to users)"
          disabled={props.isDisabled}
          error={error ?? undefined}
          dataTestAttrs={{component: 'FieldTableRow', element: 'tooltipTextInputField'}}
          className={css(styles.tooltipTextInput)}
        />
        {error && <ErrorMessage error={error} />}
      </>
    );
  }
  return props.field.tooltipText ? (
    <div className={css(styles.tooltipTextDisplay)}>
      <InfoIcon />
      <span className={css(styles.tooltipText)}>{props.field.tooltipText || 'No Tooltip Text'}</span>
    </div>
  ) : null;
}

const styles = StyleSheet.create({
  tooltipText: {color: GRAY_DARK, fontSize: '11px', fontStyle: 'italic', paddingLeft: '8px'},
  tooltipTextDisplay: {display: 'flex', alignItems: 'center'},
  tooltipTextInput: {resize: 'vertical'},
});
